import React from 'react';

import {Code} from '../Code';
import type {FileInfo} from '../fileInfoFromName';
import type {FileBrowserFile} from '../types';

interface CodePreviewProps {
  file: FileBrowserFile;
  fileInfo: FileInfo;
  fileBody: string | undefined;
}

export function CodePreview({file, fileBody, fileInfo}: CodePreviewProps) {
  return (
    <Code
      file={file}
      language={fileInfo.language ?? 'text'}
      text={fileBody ?? ''}
    />
  );
}
